import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectPathname } from 'rdx/router';

import { MenuContext } from 'root/navigation/navStructureUtils';

import { parseUrlLocation } from './parseUrlLocation';
import { useLocalizedDocumentTitle } from 'root/navigation/useLocalizedDocumentTitle';

export const usePathAwareDocumentTitle = (): void => {
  const pathname = useSelector(selectPathname);
  const menuCategories = useContext(MenuContext)?.menu;

  const pageTitleIntlId = useMemo(() => {
    const { category, item } = parseUrlLocation(pathname, menuCategories);
    return item?.titleIntlId || category?.titleIntlId || null;
  }, [menuCategories, pathname]);

  useLocalizedDocumentTitle(pageTitleIntlId, { shouldUseAppNameSuffix: true });
};
